// import React from 'react';
// import loadable from '@loadable/component';
// import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

// const LogoListing = (props) => {
//   if (!props?.fields || !props.params) return <GenericPlaceholder componentName="LogoListing" />;
//   const Component = loadable(() => import('./LogoListingComponent.js'), { ssr: false });
//   return <Component {...props} />;
// };

// export default LogoListing;

import React, { useState } from 'react';
import LogoListingHeader from './shared/header';
import LogoListingGrid from './shared/grid';
import CustomModal from '../Shared/components/CustomModal';
import LogoListingCarousel from './shared/carousel';
import useWindowSize from '../Shared/hooks/useWindowSize';
import clsx from 'clsx';

const LogoListingComponent = (props) => {
  const carouselMode = props.params.carouselMode === '1';
  const carouselModeLimit = !isNaN(Number(props.params.sizeOfCarousel))
    ? Number(props.params.sizeOfCarousel)
    : -1;
  const { heading, label, text, items } = props?.fields;
  const [modalVisible, setModalVisible] = useState(false);
  const [sizeX] = useWindowSize();
  const isMobile = sizeX <= 576;

  const needShowAll = (carouselMode && items.length >= 9) || isMobile;

  const showModal = () => setModalVisible(true);
  const hideModal = () => setModalVisible(false);

  return (
    <div className={clsx('content', 'add-margins', props?.params?.Styles)}>
      <LogoListingHeader
        title={heading}
        description={text}
        total={items.length}
        totalLabel={label}
        renderButton={needShowAll}
        onClick={showModal}
      />
      {carouselMode || isMobile ? (
        <LogoListingCarousel items={items} mobile={isMobile} limit={carouselModeLimit} />
      ) : (
        <LogoListingGrid items={items} />
      )}
      {needShowAll && (
        <CustomModal visible={modalVisible} onClose={hideModal}>
          <LogoListingHeader onClick={hideModal} mode="modal" title={heading} description={text} />
          <LogoListingGrid items={items} mode="modal" />
        </CustomModal>
      )}
    </div>
  );
};

export default LogoListingComponent;
